// extracted by mini-css-extract-plugin
export default {"item":"UserComment_item__YF7hy","bubble":"UserComment_bubble__71-NM","header":"UserComment_header__-a05+","comment":"UserComment_comment__2cVpB"};